import { SharedPalette } from "~/types/material-ui";
import * as tokens from "./tokens";

// https://www.figma.com/design/L3iS3IX1XB1GhywMyqFnMD/Mondoo-Brand-Design-System?node-id=272-5148&t=z6cWWNaDf6GG4FQf-4
export const sharedPalette: SharedPalette = {
  primary: {
    main: tokens.mondooPurple.main,
    light: tokens.mondooPurple.light,
    dark: tokens.mondooPurple.dark,
    darker: tokens.mondooPurple.darker,
    gradient: tokens.mondooPurple.gradient,
    contrastText: tokens.white,
  },
  secondary: {
    main: tokens.mondooBlue.main,
    light: tokens.mondooBlue.light,
    lighter: tokens.mondooBlue.lighter,
    dark: tokens.mondooBlue.dark,
    darker: tokens.mondooBlue.darker,
    gradient: tokens.mondooBlue.gradient,
    contrastText: tokens.white,
  },
  error: {
    main: tokens.error.main,
    light: tokens.error.light,
    lighter: tokens.error.lighter,
    dark: tokens.error.dark,
    gradient: tokens.error.gradient,
    contrastText: tokens.white,
  },
  warning: {
    main: tokens.warning.main,
    light: tokens.warning.light,
    dark: tokens.warning.dark,
    gradient: tokens.warning.gradient,
    contrastText: tokens.black,
  },
  critical: {
    main: tokens.critical.main,
    light: tokens.critical.light,
    dark: tokens.critical.dark,
    gradient: tokens.critical.gradient,
    contrastText: tokens.white,
  },
  high: {
    main: tokens.high.main,
    light: tokens.high.light,
    dark: tokens.high.dark,
    gradient: tokens.high.gradient,
    contrastText: tokens.white,
  },
  medium: {
    main: tokens.medium.main,
    light: tokens.medium.light,
    dark: tokens.medium.dark,
    gradient: tokens.medium.gradient,
    contrastText: tokens.white,
  },
  low: {
    main: tokens.low.main,
    light: tokens.low.light,
    dark: tokens.low.dark,
    gradient: tokens.low.gradient,
    contrastText: tokens.black,
  },
  // none and good are the same for CVE purposes; none will be treated differently
  // when looking at general-purpose reports
  none: {
    main: tokens.none.main,
    light: tokens.none.light,
    dark: tokens.none.dark,
    gradient: tokens.none.gradient,
    contrastText: tokens.black,
  },
  unknown: {
    main: tokens.unknown.main,
    light: tokens.unknown.light,
    dark: tokens.unknown.dark,
    gradient: tokens.unknown.gradient,
    contrastText: tokens.black,
  },
  unscored: {
    main: tokens.unknown.main,
    light: tokens.unknown.light,
    dark: tokens.unknown.dark,
    gradient: tokens.unknown.gradient,
    contrastText: tokens.black,
  },
  errorScan: {
    main: tokens.errorScan.main,
    light: tokens.errorScan.light,
    dark: tokens.errorScan.dark,
    gradient: tokens.errorScan.gradient,
    contrastText: tokens.black,
  },
  // score rating
  fail: {
    main: tokens.critical.main,
    light: tokens.critical.light,
    dark: tokens.critical.dark,
    gradient: tokens.critical.gradient,
    contrastText: tokens.white,
  },
  poor: {
    main: tokens.high.main,
    light: tokens.high.light,
    dark: tokens.high.dark,
    gradient: tokens.high.gradient,
    contrastText: tokens.white,
  },
  fair: {
    main: tokens.medium.main,
    light: tokens.medium.light,
    dark: tokens.medium.dark,
    gradient: tokens.medium.fairGradient,
    contrastText: tokens.white,
  },
  good: {
    main: tokens.low.main,
    light: tokens.low.light,
    dark: tokens.low.dark,
    gradient: tokens.low.gradient,
    contrastText: tokens.black,
  },
  excellent: {
    main: tokens.none.main,
    light: tokens.none.light,
    dark: tokens.none.dark,
    gradient: tokens.none.gradient,
    contrastText: tokens.black,
  },
  unrated: {
    main: tokens.unknown.main,
    light: tokens.unknown.light,
    dark: tokens.unknown.dark,
    gradient: tokens.unknown.gradient,
    contrastText: tokens.black,
  },
};
